import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "维护停车区信息")], -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-left": "10px"
  }
}, "辆", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-left": "10px"
  }
}, "%", -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-left": "10px"
  }
}, "%", -1);
const _hoisted_6 = {
  style: {
    "height": "700px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _component_MapContainer = _resolveComponent("MapContainer");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(`${$data.edit ? '修改' : '增加'}停车区`), 1)]), _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "站点名称",
        prop: "parkName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.parkName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.parkName = $event),
          placeholder: "请输入站点名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "所属区域",
        prop: "parkArea"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_cascader, {
          modelValue: $data.formModel.parkArea,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formModel.parkArea = $event),
          placeholder: "请选择区域信息",
          style: {
            "width": "100%"
          },
          props: $data.areaProps,
          options: $data.areas
        }, null, 8, ["modelValue", "props", "options"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "停车规范",
        prop: "parkSp"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.formModel.parkSp,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formModel.parkSp = $event),
          "active-value": 0,
          "inactive-value": 1,
          "active-text": "启用",
          "inactive-text": "禁用"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), $data.formModel.parkSp === 0 ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: "停车规范方式",
        prop: "spWay"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.formModel.spWay,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formModel.spWay = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: "道钉"
          }), _createVNode(_component_el_radio, {
            label: "AI摄像头"
          }), _createVNode(_component_el_radio, {
            label: "RFID"
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
        label: "停车范围方式",
        prop: "parkType"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.formModel.parkType,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formModel.parkType = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: "定位范围"
          }), _createVNode(_component_el_radio, {
            label: "区域范围"
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "站点容量",
        prop: "parkCapacity"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          min: 20,
          max: 100,
          modelValue: $data.formModel.parkCapacity,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.formModel.parkCapacity = $event),
          placeholder: "请输入站点容量"
        }, null, 8, ["modelValue"]), _hoisted_3]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "自定义阈值",
        prop: "thresholdStatus"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_switch, {
          modelValue: $data.formModel.thresholdStatus,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.formModel.thresholdStatus = $event),
          "active-value": 0,
          "inactive-value": 1,
          "active-text": "启用",
          "inactive-text": "禁用"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), $data.formModel.thresholdStatus === 0 ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 1,
        label: "最小阈值",
        prop: "capacityMin"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          min: 0,
          max: 100,
          modelValue: $data.formModel.capacityMin,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.formModel.capacityMin = $event),
          placeholder: "最小阈值"
        }, null, 8, ["modelValue"]), _createTextVNode(), _hoisted_4]),
        _: 1
      })) : _createCommentVNode("", true), $data.formModel.thresholdStatus === 0 ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 2,
        label: "最大阈值",
        prop: "capacityMax"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          min: 0,
          max: 100,
          modelValue: $data.formModel.capacityMax,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.formModel.capacityMax = $event),
          placeholder: "最大阈值"
        }, null, 8, ["modelValue"]), _createTextVNode(), _hoisted_5]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
        label: "停车区区域"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $options.begin
        }, {
          default: _withCtx(() => [_createTextVNode("编辑停车区域")]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "详细地址",
        prop: "parkAdd"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          readonly: "",
          modelValue: $data.formModel.parkAdd,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.formModel.parkAdd = $event),
          placeholder: "绘制区域后自动获取"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: $options.submitForm
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(`${$data.edit ? '修改' : '增加'}`), 1)]),
          _: 1
        }, 8, ["onClick"])), [[_directive_permission, ['park_add', 'park_edit']]]), _createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = () => {
            this.$router.go(-1);
          })
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    title: "绘制停车区域",
    "destroy-on-close": "",
    modelValue: $data.isAdd,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.isAdd = $event),
    width: "70%",
    center: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_MapContainer, {
      addressData: $data.address,
      type: $data.type,
      parkType: $data.parkType,
      onTransfer: $options.getAddressData,
      onClose: $options.Close
    }, null, 8, ["addressData", "type", "parkType", "onTransfer", "onClose"])])]),
    _: 1
  }, 8, ["modelValue"])]);
}